"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.time = exports.date = exports.Timer = void 0;
exports.gettmr = gettmr;
exports.settmr = settmr;
exports.getdate = getdate;
exports.gettime = gettime;
exports.wait = wait;
exports.sett = sett;
exports.clrt = clrt;
exports.eerr = eerr;
const ediabasx_core_1 = require("@emdzej/ediabasx-core");
const register_values_1 = require("./register-values");
const trap_bits_1 = require("../trap-bits");
class Timer {
    now;
    baseMs = 0;
    startedAt;
    constructor(now = () => Date.now()) {
        this.now = now;
        this.startedAt = this.now();
    }
    set(valueMs = 0) {
        this.baseMs = valueMs;
        this.startedAt = this.now();
    }
    read() {
        return this.baseMs + (this.now() - this.startedAt);
    }
}
exports.Timer = Timer;
function resolveTimeValue(registers, value) {
    return typeof value === "number" ? value : (0, register_values_1.getIntValue)(registers, value);
}
function setDateTimeBytes(registers, destination, bytes) {
    if (destination.kind === "S") {
        registers.setSBinary(destination.index, bytes);
        return;
    }
    // Pack little-endian into the int register's natural size.
    let value = 0;
    for (let i = bytes.length - 1; i >= 0; i--) {
        value = ((value << 8) | bytes[i]) >>> 0;
    }
    (0, register_values_1.setIntValue)(registers, destination, value);
}
/**
 * ISO-8601 week-of-year (Monday-based, with weeks 1 having 4+ days in the new year).
 * Mirrors C# CultureInfo.InvariantCulture.Calendar.GetWeekOfYear with FirstFourDayWeek/Monday.
 */
function isoWeekOfYear(date) {
    const target = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNr = (target.getUTCDay() + 6) % 7;
    target.setUTCDate(target.getUTCDate() - dayNr + 3);
    const firstThursday = new Date(Date.UTC(target.getUTCFullYear(), 0, 4));
    const firstDayNr = (firstThursday.getUTCDay() + 6) % 7;
    firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNr + 3);
    const diffMs = target.getTime() - firstThursday.getTime();
    return 1 + Math.round(diffMs / (7 * 24 * 3600 * 1000));
}
function gettmr(registers, state, destination) {
    (0, register_values_1.setIntValue)(registers, destination, state.errorTrapMask);
}
function settmr(registers, state, value) {
    state.errorTrapMask = resolveTimeValue(registers, value);
}
/**
 * BEST2 getdate — writes a 5-byte packed array:
 *   [day, month, year%100, weekOfYear, dayOfWeek (Mon=1..Sun=7)].
 * Mirrors C# OpDate.
 */
function getdate(registers, destination, now = new Date()) {
    const day = now.getDate();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    const week = isoWeekOfYear(now);
    let dayOfWeek = now.getDay(); // 0=Sunday..6=Saturday
    if (dayOfWeek === 0)
        dayOfWeek = 7;
    const bytes = new Uint8Array([
        day & 0xff,
        month & 0xff,
        year % 100 & 0xff,
        week & 0xff,
        dayOfWeek & 0xff,
    ]);
    setDateTimeBytes(registers, destination, bytes);
}
/**
 * BEST2 gettime — writes a 3-byte packed array: [hour, minute, second].
 * Mirrors C# OpTime.
 */
function gettime(registers, destination, now = new Date()) {
    const bytes = new Uint8Array([
        now.getHours() & 0xff,
        now.getMinutes() & 0xff,
        now.getSeconds() & 0xff,
    ]);
    setDateTimeBytes(registers, destination, bytes);
}
function wait(registers, duration) {
    const durationSeconds = Math.max(0, resolveTimeValue(registers, duration));
    return new Promise((resolve) => {
        setTimeout(resolve, durationSeconds * 1000);
    });
}
/**
 * Timer flag operations.
 * The timer flag is a separate boolean from the timer value.
 */
/** SETT - Set error trap bit */
function sett(registers, state, value) {
    let bit = resolveTimeValue(registers, value);
    if (bit === 0) {
        bit = 0x40000000;
    }
    state.errorTrapBitNr = bit;
}
/** CLRT - Clear error trap bit */
function clrt(state) {
    state.errorTrapBitNr = -1;
}
/** EERR - Execute error */
function eerr(state) {
    if (state.errorTrapBitNr >= 0) {
        // Check if the current trap bit corresponds to a specific known error
        // Iterate over known trap bits to find a match
        for (const [errorCode, bitNr] of Object.entries(trap_bits_1.TrapBitDict)) {
            if (bitNr === state.errorTrapBitNr) {
                const code = Number(errorCode);
                throw new ediabasx_core_1.EdiabasError(code, `Error trap triggered: ${state.errorTrapBitNr}`);
            }
        }
        // Fallback to generic internal error if no specific mapping found
        throw new ediabasx_core_1.EdiabasError(ediabasx_core_1.EdiabasErrorCodes.EDIABAS_BIP_0000, `Error trap triggered: ${state.errorTrapBitNr}`);
    }
}
exports.date = getdate;
exports.time = gettime;
//# sourceMappingURL=time.js.map